//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "checkbox",
	props: { data: { required: true } },
	methods: {
		emitChange() {
			this.$emit("checkToggle", this.data);
		},
	},
};
